import { Package } from 'lucide-react'
import { Link } from 'react-router-dom'

interface EmptyStateProps {
  title: string
  description: string
  action?: {
    label: string
    href: string
  }
}

export default function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="text-center py-16">
      <Package className="h-12 w-12 text-dark-600 mx-auto mb-4" />
      <h3 className="text-lg font-semibold text-white mb-2">{title}</h3>
      <p className="text-dark-400 mb-6 max-w-md mx-auto">{description}</p>

      {action && (
        <Link to={action.href} className="btn-primary">
          {action.label}
        </Link>
      )}
    </div>
  )
}
